import React, { useState } from 'react';
import LeadershipAssessment from './LeadershipAssessment.js'; // Make sure you have renamed your old App.js
import CareerBlueprint from './CareerBlueprint.js';
import EnneagramAssessment from './EnneagramAssessment.js';
import './index.css';

function App() {
  const [currentAssessment, setCurrentAssessment] = useState(null);

  const renderHomepage = () => (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white p-10 rounded-xl shadow-lg text-center max-w-lg">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Assessment Center</h1>
        <p className="text-gray-600 mb-8">
          Choose an assessment to begin your journey of self-discovery.
        </p>
        <div className="flex flex-col md:flex-row gap-6">
          <button
            onClick={() => setCurrentAssessment('leadership')}
            className="w-full bg-indigo-600 text-white font-semibold py-3 px-6 rounded-lg shadow-md hover:bg-indigo-700 transition"
          >
            Take the Leader's Lens Assessment
          </button>
          <button
            onClick={() => setCurrentAssessment('career')}
            className="w-full bg-green-600 text-white font-semibold py-3 px-6 rounded-lg shadow-md hover:bg-green-700 transition"
          >
            Take the Career Blueprint Assessment
          </button>
          <button
            onClick={() => setCurrentAssessment('enneagram')}
            className="w-full bg-purple-700 hover:bg-purple-800 text-white font-bold py-4 px-6 rounded-lg shadow-lg transition-transform transform hover:scale-105"
          >
            <h3 className="text-xl font-semibold">Enneagram Assessment</h3>
            <p className="mt-2 text-sm">Discover your core motivations and leadership style.</p>
          </button>
        </div>
      </div>
    </div>
  );

  const renderAssessment = () => {
    switch (currentAssessment) {
      case 'leadership':
        return <LeadershipAssessment />;
      case 'career':
        return <CareerBlueprint />;
      case 'enneagram':
        return <EnneagramAssessment />;
      default:
        return renderHomepage();
    }
  };

  return (
    <div>
      {renderAssessment()}
    </div>
  );
}

export default App;